import hbscan from "../../api/hbscan";
import { IWorkSchedule } from "../../models/workSchedule";
import AuthService from "../auth/AuthService";

const baseUrl = "/api/hbscan/WorkSchedule";

class WorkScheduleService {
    GetByUser = async (userId: number): Promise<IWorkSchedule[]> => {
        const URI = `${baseUrl}/GetSchedulesByUser`;
        return (
            await hbscan.get<IWorkSchedule[]>(URI, {
                headers: { Authorization: AuthService.guid },
                params: { userId },
            })
        ).data;
    };

    GetByCompany = async (): Promise<IWorkSchedule[]> => {
        const URI = `${baseUrl}/GetSchedulesByCompany`;
        return (
            await hbscan.get<IWorkSchedule[]>(URI, {
                headers: { Authorization: AuthService.guid },
            })
        ).data;
    };

    UpsertMany = async (userId: number, schedules: IWorkSchedule[]) => {
        const URI = `${baseUrl}/UpsertWorkSchedules`;

        return (
            await hbscan.post<void>(URI, schedules, {
                headers: { Authorization: AuthService.guid },
                params: { userId },
            })
        ).data;
    };
}

const WorkScheduleServiceInstance = new WorkScheduleService();

export default WorkScheduleServiceInstance;
